export default __webpack_public_path__ + "static/media/logo.b2292b7f.svg";